export const primary = "#A70B36";
export const secondary = "#CCC";
export const gray = "#555";
export const backgroundGray = "#eee";

export const white = "#fff";

// Background colors
export const softWhite = "#f7f7f7";
